import { render, staticRenderFns } from "./center.vue?vue&type=template&id=5c85a257&scoped=true"
import script from "./center.vue?vue&type=script&lang=ts"
export * from "./center.vue?vue&type=script&lang=ts"
import style0 from "./center.vue?vue&type=style&index=0&id=5c85a257&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c85a257",
  null
  
)

export default component.exports